"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doubleMapDelete = doubleMapDelete;
exports.doubleMapGet = doubleMapGet;
exports.doubleMapHas = doubleMapHas;
exports.doubleMapSet = doubleMapSet;
exports.getS3ErrorFilePath = getS3ErrorFilePath;
exports.getTempFilePath = getTempFilePath;
exports.makeTempDir = makeTempDir;
exports.parseHeader = parseHeader;
exports.parseHeaders = parseHeaders;
exports.randomString = randomString;
exports.setMapDelete = setMapDelete;
exports.setMapHas = setMapHas;
exports.setMapSet = setMapSet;
exports.stripSpecialCharactersAndSpaces = stripSpecialCharactersAndSpaces;
exports.toRawAdjustment = toRawAdjustment;
var _nodeCrypto = require("node:crypto");
var _promises = require("node:fs/promises");
var _nodeOs = require("node:os");
var _nodePath = require("node:path");
var _commonUtils = require("@abacus/common-utils");
var _excel = require("./excel");
var _constants = require("../constants");
/**
 * Get error file path on s3
 */
function getS3ErrorFilePath(bucketName, adjustmentFileId) {
  /** Get error file path on s3. */
  return `s3://${bucketName}/${adjustmentFileId}/${adjustmentFileId}-error.xlsx`;
}
async function getTempFilePath(suffix) {
  const filePath = await makeTempDir();
  const fileName = `${randomString(8)}${suffix ?? ""}`;
  return (0, _nodePath.join)(filePath, fileName);
}
async function makeTempDir(prefix) {
  return (0, _promises.mkdtemp)((0, _nodePath.join)((0, _nodeOs.tmpdir)(), `${prefix ?? ""}${randomString(1)}`));
}
function doubleMapDelete(map, key1, key2) {
  const map2 = map.get(key1);
  if (map2 == null || !map2.delete(key2)) {
    return false;
  }
  if (map2.size == 0) {
    map.delete(key1);
  }
  return true;
}
function doubleMapGet(map, key1, key2) {
  return map.get(key1)?.get(key2);
}
function doubleMapHas(map, key1, key2) {
  return map.get(key1)?.has(key2) ?? false;
}
function doubleMapSet(map, key1, key2, value) {
  let map2 = map.get(key1);
  if (map2 == null) {
    map2 = new Map();
    map.set(key1, map2);
  }
  map2.set(key2, value);
}
function parseHeader(header) {
  const snakeCase = (0, _commonUtils.toSnakeCase)(header);
  // Remove any '*' suffix
  return snakeCase.replace(/_?\*$/, "");
}
function parseHeaders(row) {
  const headers = [];
  for (const [index, cell] of row.cells.entries()) {
    const header = parseHeader(cell.raw);
    if (_constants.ADJUSTMENT_FILE_COLUMNS.has(header)) {
      headers.push([index, header]);
    }
  }
  return headers;
}
function randomString(bytes) {
  return (0, _nodeCrypto.randomBytes)(bytes).toString("hex");
}
function setMapDelete(map, key, value) {
  const set = map.get(key);
  if (set == null || !set.delete(value)) {
    return false;
  }
  if (set.size == 0) {
    map.delete(key);
  }
  return true;
}
function setMapHas(map, key, value) {
  return map.get(key)?.has(value) ?? false;
}
function setMapSet(map, key, value) {
  let set = map.get(key);
  if (set == null) {
    set = new Set();
    map.set(key, set);
  }
  set.add(value);
}
function stripSpecialCharactersAndSpaces(str) {
  return str.replaceAll(/\xa0|\u200B/g, "").trim();
}
function toRawAdjustment(headers, cells) {
  const raw = {};
  for (const [index, key] of headers) {
    const cell = cells[index];
    if (cell != null && cell.type != _excel.CellType.Empty && cell.type != _excel.CellType.Error && cell.raw.length > 0) {
      const camelKey = (0, _commonUtils.snakeToCamelCase)(key);
      raw[camelKey] = cell.value;
    }
  }
  return raw;
}